import React from "react";

// A pass card with the pack's gem; bigger packs fan extra cards out behind
// it. Flat jam colours, no gradients or shadows (design language F).
const ShopCardGraphic = ({ amount, gem: Gem }) => {
  const getRotations = (count) => {
    if (count <= 6) return [];
    if (count === 7) return [4, -4];
    return [-8, -4, 4, 8];
  };

  const getHeights = (count) => {
    if (count <= 6) return [];
    if (count === 7) return ["tw-h-36 md:tw-h-52", "tw-h-36 md:tw-h-52"];
    return [
      "tw-h-28 md:tw-h-44",
      "tw-h-36 md:tw-h-52",
      "tw-h-36 md:tw-h-52",
      "tw-h-28 md:tw-h-44",
    ];
  };

  const getIndex = (count) => {
    if (count <= 6) return [];
    if (count === 7) return [0, 0];
    return [0, 1, 1, 0];
  };

  const getColors = (count) => {
    if (count <= 6) return [];
    if (count === 7) return ["tw-bg-jam-soft", "tw-bg-jam-soft"];
    return [
      "tw-bg-jam-line",
      "tw-bg-jam-soft",
      "tw-bg-jam-soft",
      "tw-bg-jam-line",
    ];
  };

  const rotations = getRotations(amount);
  const heights = getHeights(amount);
  const indexes = getIndex(amount);
  const colors = getColors(amount);

  return (
    <div className="tw-relative tw-flex tw-w-full tw-items-center tw-justify-center">
      {rotations.map((rotation, index) => (
        <div
          key={index}
          className={`tw-absolute tw-bottom-6 tw-mb-3 tw-w-full tw-origin-bottom tw-rounded-[26px] ${colors[index]} ${heights[index]}`}
          style={{
            zIndex: indexes[index],
            transform: `rotate(${rotation}deg)`,
          }}
        ></div>
      ))}
      <div className="tw-relative tw-z-10 tw-mb-3 tw-h-44 tw-w-full tw-overflow-hidden tw-rounded-[26px] tw-bg-jam-purple md:tw-h-60">
        <div className="jam-display tw-absolute tw--right-6 tw--top-24 tw-select-none tw-text-[300px] tw-font-extrabold tw-leading-none tw-text-white/10">
          J
        </div>
        <div className="jam-display tw-absolute tw-bottom-9 tw-left-5 tw-text-[40px] tw-font-extrabold tw-leading-none tw-text-white">
          {amount}×
        </div>
        <div className="tw-absolute tw-bottom-4 tw-left-5 tw-text-xs tw-font-extrabold tw-tracking-wider tw-text-jam-lime">
          VOICE PASSES
        </div>
      </div>
      {Gem && (
        <div className="item-gem">
          <Gem className="tw-absolute tw-right-5 tw-top-5 tw-z-20 tw-h-8" />
        </div>
      )}
    </div>
  );
};

export default ShopCardGraphic;
